var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickupPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 10) rotate(45) translate(-13.5 -10.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "13.5 1 6 19.29 6.71 20 13.5 17 20.29 20 21 19.29",
    fill: "#969FA2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupPointer);
export default __webpack_public_path__ + "static/media/pickup-pointer.09e251db0d041feedb94913d84116d0f.svg";
export { ForwardRef as ReactComponent };